import { FlightEvaluationRepository } from '@src/main/modules/reports/flight/domain/flight-evaluation.repository';

export const downloadFlightEvaluationPdf = async (
  repository: FlightEvaluationRepository,
  evaluationId: string,
): Promise<Blob> => await repository.downloadPdf(evaluationId);
